import { $voixFetch, createError, useRoute } from "#imports";
import { useVoixToast } from "@voix/composables/useVoixToast";
import { useAdminStore } from "@voix/store/adminStore";
import { usePageStore } from "@voix/store/pageStore";
import { $voixNuxtApi } from "@voix/voix-layer/composables/voixNuxtApi";
export const useQueryCurrentPage = () => {
  const adminStore = useAdminStore();
  const pageStore = usePageStore();
  const route = useRoute();
  function handleResponse(response) {
    pageStore.setPageResponse(response);
    setCurrentPageInStore(response.page);
  }
  function setCurrentPageInStore(pageData) {
    pageStore.setCurrentPage(pageData);
  }
  async function getCurrentPage(variables) {
    adminStore.isLoading = true;
    pageStore.currentPath = variables.path;
    let path = pageStore.currentPath;
    if (!path.startsWith("/"))
      path = `/${path}`;
    const isAdmin = route.query["voix-sync"] !== void 0 || route.name === "voix-studio-en";
    const responsesRoute = isAdmin ? `/api/admin/voix/responses${path}` : `/api/voix/responses${path}`;
    const { data, error } = await $voixNuxtApi(responsesRoute);
    if (error.value) {
      throw createError({
        statusCode: 503,
        statusMessage: "API Service Unavailable",
        fatal: true
      });
    }
    if (data.value)
      await handleResponse(data.value);
    adminStore.isLoading = false;
    return data;
  }
  async function fetchCurrentPage(variables) {
    const adminStore2 = useAdminStore();
    adminStore2.isLoading = true;
    const pageStore2 = usePageStore();
    pageStore2.currentPath = variables.path;
    let path = pageStore2.currentPath;
    if (!path.startsWith("/"))
      path = `/${path}`;
    const isAdmin = route.query["voix-sync"] !== void 0 || route.name === "voix-studio-en";
    const responsesRoute = isAdmin ? `/api/admin/voix/responses${path}` : `/api/voix/responses${path}`;
    const data = await $voixFetch(responsesRoute).catch((error) => {
      console.error("Error fetching current page", error);
      throw createError({
        statusCode: 503,
        statusMessage: "API Service Unavailable",
        fatal: true
      });
    });
    if (data)
      handleResponse(data);
    adminStore2.isLoading = false;
    return data;
  }
  async function updateCurrentPage(variables) {
    const adminStore2 = useAdminStore();
    const voixToast = useVoixToast();
    adminStore2.isLoading = true;
    const request = await $voixNuxtApi(
      `/api/admin/voix/pages/${variables.id}`,
      {
        method: "PUT",
        body: variables
      }
    );
    adminStore2.isLoading = false;
    if (request.data.value) {
      setCurrentPageInStore(request.data.value);
      voixToast.add(`Page Updated`, "msg");
      return request;
    } else {
      if (request.error.value) {
        const error = request.error.value;
        throw new Error(error.toString());
      }
      throw new Error("Unable to save");
    }
  }
  return { getCurrentPage, fetchCurrentPage, updateCurrentPage };
};
